var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGroupNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 32,
    viewBox: "0 0 34.5 32",
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 28.5V26.75C1.5 22.8841 4.634 19.75 8.5 19.75H15.5C19.3659 19.75 22.5 22.8841 22.5 26.75V28.5M22.5 14.5C25.3996 14.5 27.75 12.1495 27.75 9.25C27.75 6.35051 25.3996 4 22.5 4M33 28.5V26.75C33 22.8841 29.8659 19.75 26 19.75H25.125M17.25 9.25C17.25 12.1495 14.8996 14.5 12 14.5C9.10051 14.5 6.75 12.1495 6.75 9.25C6.75 6.35051 9.10051 4 12 4C14.8996 4 17.25 6.35051 17.25 9.25Z",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupNetwork);
export default __webpack_public_path__ + "static/media/icon_group_network.b0b73d685db0039355f549d58028cbdf.svg";
export { ForwardRef as ReactComponent };